import React, {useState, useEffect} from 'react';
import './styles.css';
import AccountCircleOutlinedIcon from
  '@mui/icons-material/AccountCircleOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import NavBar from './Navbar';
import TokenManager from './TokenManager';
import Avatar from 'react-avatar';
import Popup from './Popup';
/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Home Page.
  */
function Home() {
  const [info, setInfo] = useState([]);
  const [ad, setAd] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const memberId = TokenManager.getId();

    axios.get(` https://blooming-springs-86289.herokuapp.com/api/login/info/${memberId}`)
        .then((response) => {
          return (
            setInfo(response.data[0])
          );
        });
    axios.get(` https://blooming-springs-86289.herokuapp.com/api/advertisement/${memberId}`)
        .then((response) => {
        // console.log(response.data[0].img)
          setAd(response.data[0].img);
        })
        .catch((error) => {
          console.log(error);
        });
  }, []);


  return (
    <>
      <NavBar />

      <h2 className='welcome'>Hello {info.first_name}!
      </h2>
      <div className='homeinfo'>
        <div>Current Tier: {info.tier}</div>
        <Avatar name={info.first_name} />
        <div>Current Points:
          {info.points}
        </div>
      </div>
      <hr></hr>


      <div id="container">

        <button id="nav-button" onClick={() => navigate('/profile')} >
          <AccountCircleOutlinedIcon fontSize='large' />
          <h3 id="text">Profile</h3>
        </button>
        <button id="nav-button" onClick={() => navigate('/redeem')} >
          <LocalAtmOutlinedIcon fontSize='large' />
          <h3 id="text">Redeem</h3>
        </button>
        <button id="nav-button" onClick={() => navigate('/receipt')} >
          <ReceiptLongOutlinedIcon fontSize='large' />
          <h3 id="text">Receipt</h3>
        </button>
      </div>
      <div className='popup'>
        {isOpen && <Popup
          content={<>
            <img className='adimg' src={ad} />
          </>}
          handleClose={togglePopup}
        />}
      </div>

    </>
  );
}

export default Home;
